/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:00:33
 */

import {type AnySchema, object} from 'yup';

// helpers
import {genericFieldsSchema, HandleProps} from '~/helpers/form-fields';

// types
import type {RealPennedLetterField, RealPennedLetterFields} from './fields-info';

export type RealPennedLetterProps = HandleProps<RealPennedLetterFields>

export const schema = object<RealPennedLetterFields, Record<RealPennedLetterField, AnySchema>>()
  .shape({
    ...genericFieldsSchema,
  });
